import { DashboardLayout } from "../layouts/DashboardLayout";
import { DashboardContent } from "../collections/dashboard/DashboardContent";

export const DashboardPage = () => (
  <DashboardLayout>
    <DashboardContent />
  </DashboardLayout>
);
